export default class Contract {
  // 获取请假天数
  static getQJdays(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaPayApproval/getQjDays', 'get', data, axiosOption, httpOption);
  }
  // 判断是否可以请假
  static askRecord(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaPayApproval/checkRecord', 'get', data, axiosOption, httpOption);
  }
}